export const SET_LOADING_USER = 'SET_LOADING_USER'
export const SET_TOKEN = "SET_TOKEN"
export const SET_ME = "SET_ME"
export const SET_USER_INVALID = "SET_USER_VALID"